import React, { useState } from 'react';
import { Col, Container } from 'react-bootstrap';
import FilterPanel from './component/FilterPanel';
import useUpdateAndReminder from './hooks/useUpdateAndReminder';
import '../Messages/MessagingScreen.scss';
import MessageListSkeleton from '../Messages/skeleton/MessageListSkeleton';
import MessagesList from '../Messages/MessagesList';
import MessageDetailSelecton from '../Messages/skeleton/MessageDetailSelecton';
import MessageDetailComponent from '../Messages/component/MessageDetailComponent';
import CustomPaginationItemsDisplay from '../../common/pagination/CustomPaginationItemsDisplay';
import CustomPagination from '../../common/pagination';
import CustomClientError from 'src/Admin/errorhandling/CustomClientError';

function UpdatesRemainder({ selectedTabLocal }) {
  const [accessibilityCurrentPage, setAccessibilityCurrentPage] = useState(0);
  const {
    SORT_BY_DROPDOWN_OPTIONS = [],
    sortByData,
    setSortByData,
    searchText,
    onSearch,
    listLoading,
    ListUser,
    selectedIndex,
    updateAndReminderData,
    totalRecords,
    pageSize,
    pageSizeHandler,
    currentPage,
    paginationHandler,
    displayPaginationMininumCount,
    listApiDataNotFoundError,
    listApiServerError,
    downloadFileHandler,
    downloadAllFileHandler,
    setCurrentPage,
    getSanitizedContent,
    recordsPerPage,
  } = useUpdateAndReminder({ selectedTabLocal });
  return (
    <div className="for_messaging">
      <div>
        <FilterPanel
          SORT_BY_DROPDOWN_OPTIONS={SORT_BY_DROPDOWN_OPTIONS}
          sortByData={sortByData}
          setSortByData={setSortByData}
          setCurrentPage={setCurrentPage}
          searchText={searchText}
          onSearch={onSearch}
        />
      </div>
      <Container>
        {listLoading ? (
          <div className="row">
            <Col className="bg-white pr-0 pl-0 mr-5">
              <MessageListSkeleton />
            </Col>
            <Col md={7} className="pr-0">
              <MessageDetailSelecton />
            </Col>
          </div>
        ) : listApiServerError ? (
          <CustomClientError
            ErrorHeading={
              listApiDataNotFoundError
                ? 'No result found!'
                : 'Something went wrong with request!'
            }
            ErrorMessage={
              listApiDataNotFoundError
                ? 'No result found with the selected filters, Please try again'
                : 'Please try again.'
            }
          />
        ) : (
          <>
            <div className="d-flex justify-content-between mt-4 mb-4">
              <div className="sr-only" role="status">
                {`Total ${totalRecords} results found`}
              </div>
              {totalRecords > displayPaginationMininumCount && !listLoading ? (
                <CustomPaginationItemsDisplay
                  pageSize={pageSize}
                  recordsPerPage={recordsPerPage}
                  setPageSize={pageSizeHandler}
                  prefixMessage="Records per page"
                  suffixMessage={`Showing ${
                    currentPage * pageSize - pageSize + 1
                  } - ${
                    pageSize * currentPage < totalRecords
                      ? pageSize * currentPage
                      : totalRecords
                  } of ${totalRecords} results`}
                />
              ) : null}

              <div className="d-flex align-items-center">
                {totalRecords > displayPaginationMininumCount &&
                !listLoading ? (
                  <CustomPagination
                    className="p-0 m-0"
                    pageSize={pageSize}
                    currentPage={currentPage}
                    totalCount={totalRecords}
                    onPageChange={paginationHandler}
                    accessibilityPagination={true}
                    accessibilityCurrentPage={accessibilityCurrentPage}
                    setAccessibilityCurrentPage={setAccessibilityCurrentPage}
                  />
                ) : null}
              </div>
            </div>
            <div className="d-flex row">
              <Col className="bg-white pr-0 pl-0 h-100 mr-5">
                <MessagesList
                  ListUser={ListUser}
                  selectedIndex={selectedIndex}
                  data={updateAndReminderData}
                />
              </Col>
              <Col lg={7} md={7} className="pr-0 pl-0">
                {listLoading ? (
                  <MessageDetailSelecton />
                ) : (
                  <MessageDetailComponent
                    isComposing={false}
                    setIsComposing={() => {}}
                    replyEnabled={false}
                    setReplyEnabled={() => {}}
                    selectedData={[updateAndReminderData[selectedIndex]]}
                    isUpdateAndReminder={true}
                    onDownload={(item) => downloadFileHandler(item)}
                    onDownloadAll={(items) => downloadAllFileHandler(items)}
                    getSanitizedContent={getSanitizedContent}
                  />
                )}
              </Col>
            </div>
            <div className="d-flex justify-content-between mt-4 mb-4">
              {totalRecords > displayPaginationMininumCount && !listLoading ? (
                <CustomPaginationItemsDisplay
                  pageSize={pageSize}
                  setPageSize={pageSizeHandler}
                  prefixMessage="Records per page"
                  suffixMessage={`Showing ${
                    currentPage * pageSize - pageSize + 1
                  } - ${
                    pageSize * currentPage < totalRecords
                      ? pageSize * currentPage
                      : totalRecords
                  } of ${totalRecords} results`}
                />
              ) : null}

              <div className="d-flex align-items-center">
                {totalRecords > displayPaginationMininumCount &&
                !listLoading ? (
                  <CustomPagination
                    className="p-0 m-0"
                    pageSize={pageSize}
                    currentPage={currentPage}
                    totalCount={totalRecords}
                    onPageChange={paginationHandler}
                    accessibilityPagination={true}
                    accessibilityCurrentPage={accessibilityCurrentPage}
                    setAccessibilityCurrentPage={setAccessibilityCurrentPage}
                  />
                ) : null}
              </div>
            </div>
          </>
        )}
      </Container>
    </div>
  );
}

export default UpdatesRemainder;
